import { useOtPurposesByStep } from "@jti/rest-api";
const getEmptyOtPurposes = () => ({ data: undefined, isError: false, isFetching: false });
// Hook created to conditionally fetch the purposes for the new password form - requested in https://jira.jtiweb.co.uk/browse/DESP-77225
// as the EVO throws error when the purposes are fetched for online-reset-password. Should be only fetched for offline-password-reset
export const useNewPasswordOtPurposes = (isOtPurposesEnabled) => {
    const getNewPasswordOtPurposes = isOtPurposesEnabled ? useOtPurposesByStep : getEmptyOtPurposes;
    return getNewPasswordOtPurposes("set_password");
};
